<template>
  <div class="zw-product-module">
    <!--背景头部-->
    <div class="zw-product-head-img">
      <div class="zw-product-head-left">
        <div class="zw-head-lf-top">
          {{ tobWebObject.title }}
        </div>
        <span class="zw-head-lf-details">
          {{ tobWebObject.description }}
        </span>
        <div class="zw-head-lf-btn">
          <el-button
            type="primary"
            round
            @click="onFreeTrialClick"
          >免费体验</el-button>
          <el-button
            style="margin-left: 32px"
            type="primary"
            round
            plain
            @click="onPresentaClick"
          >申请演示</el-button>
        </div>
      </div>
      <div class="zw-product-head-right">
        <img
          :src="pictureBaseUrl + tobWebObject.file"
          width="100%"
          height="100%"
          alt=""
        >
      </div>
    </div>
    <!--产品矩阵-->
    <div class="zw-product-list zw-product-matter">
      <div class="zw-product-title">
        <span class="zw-product-english">Product Ecosystem</span>
        <div class="zw-product-chinese">产品矩阵</div>
      </div>
      <div class="zw-product-grid">
        <div v-for="(item, index) in productMatrix" :key="index" class="zw-product-card">
          <div class="zw-product-card-content">
            <div class="zw-product-card-title">{{ item.shortName }}</div>
            <div class="zw-product-card-desc">{{ item.overview }}</div>
          </div>
          <div class="zw-product-card-icon">
            <img :src="pictureBaseUrl + item.topImage" alt="">
          </div>
          <div class="zw-product-card-overlay">
            <span
              class="zw-product-card-link"
              @click="onProductDetailClick(item)"
            >查看详情 <i class="el-icon-arrow-right" /></span>
          </div>
        </div>
      </div>
    </div>
    <!--服务矩阵-->
    <div class="zw-product-serve zw-product-matter">
      <div class="zw-product-title">
        <span class="zw-product-english">Service Ecosystem</span>
        <div class="zw-product-chinese">服务矩阵</div>
      </div>
      <div class="zw-serve-grid">
        <div
          v-for="(item, index) in serviceMatrix"
          :key="index"
          class="zw-serve-card"
          :style="{ backgroundImage: `url(${pictureBaseUrl + item.file})` }"
        >
          <div class="zw-serve-card-content">
            <div class="zw-serve-card-title">{{ item.title }}</div>
            <div class="zw-serve-line">
              <div class="zw-serve-line-fill" />
            </div>
            <div class="zw-serve-card-desc">{{ item.description }}</div>
          </div>
        </div>
      </div>
    </div>

    <!--技术与安全能力-->
    <div class="zw-product-safety zw-product-matter">
      <div class="zw-product-title">
        <span class="zw-product-english">Security & Infrastructure</span>
        <div class="zw-product-chinese">技术与安全能力</div>
      </div>
      <div class="zw-safety-grid">
        <div v-for="(item, index) in safetyMatrix" :key="index" class="zw-safety-card">
          <div class="zw-safety-card-icon">
            <img :src="pictureBaseUrl + item.file" alt="">
          </div>
          <div class="zw-safety-card-title">{{ item.title }}</div>
          <div class="zw-safety-card-desc">{{ item.description }}</div>
        </div>
      </div>
    </div>
    <!--获取解决方案-->
    <div class="zw-obtain-solution">
      <div
        class="zw-obtain-container"
        :style="{ backgroundImage:'url('+ pictureBaseUrl + bottomWebObject.file +')'}"
      >
        <div class="zw-obtain-content">
          <div class="zw-obtain-title">{{ bottomWebObject.title }}</div>
          <div class="zw-obtain-desc">{{ bottomWebObject.description }}</div>
          <div class="zw-obtain-buttons">
            <button
              class="zw-obtain-btn zw-obtain-btn-primary"
              @click="onFreeTrialClick"
            >免费体验</button>
            <button
              class="zw-obtain-btn zw-obtain-btn-secondary"
              @click="onPresentaClick"
            >预约演示</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  getProductWebList,
  getTopWebList,
  getBottomWebList,
  getServeWebList,
  getAbilityWebList
} from '@/js/productModule'
import { pictureBaseUrl } from '@/utils/request'
export default {
  name: 'ProductModule',
  data() {
    return {
      tobWebObject: {
        title: '',
        description: '',
        file: ''
      },
      bottomWebObject: {
        title: '',
        description: '',
        file: ''
      },
      pictureBaseUrl: pictureBaseUrl,
      safetyMatrix: [],
      serviceMatrix: [],
      productMatrix: []
    }
  },
  created() {
    this.getTopWebList()
    this.getProductWebList()
    this.getServeWebList()
    this.getAbilityWebList()
    this.getBottomWebList()
  },
  methods: {
    // 顶部设置
    getTopWebList() {
      getTopWebList().then((res) => {
        if (res.status === 200) {
          this.tobWebObject = res.data
        } else {
          this.tobWebObject = {
            title: '',
            description: '',
            file: ''
          }
        }
      })
    },
    // 产品列表
    getProductWebList() {
      getProductWebList().then((res) => {
        if (res.status === 200) {
          this.productMatrix = res.data
        } else {
          this.productMatrix = []
        }
      })
    },
    // 服务矩阵
    getServeWebList() {
      getServeWebList().then((res) => {
        if (res.status === 200) {
          this.serviceMatrix = res.data
        } else {
          this.serviceMatrix = []
        }
      })
    },
    // 技术与安全能力
    getAbilityWebList() {
      getAbilityWebList().then((res) => {
        if (res.status === 200) {
          this.safetyMatrix = res.data
        } else {
          this.safetyMatrix = []
        }
      })
    },
    // 底部设置
    getBottomWebList() {
      getBottomWebList().then((res) => {
        if (res.status === 200) {
          this.bottomWebObject = res.data
        } else {
          this.bottomWebObject = {
            title: '',
            description: '',
            file: ''
          }
        }
      })
    },
    // 查看详情
    onProductDetailClick(item) {
      this.$router.push({
        path: '/productDetails',
        query: {
          id: item.id
        }
      })
    },
    // 免费体验
    onFreeTrialClick() {
      // 1. 解析出完整 URL
      const routeData = this.$router.resolve({
        path: '/IntegratedEntrance'
      })
      // 2. 新页签打开
      window.open(routeData.href, '_blank')
    },
    // 申请演示
    onPresentaClick() {
      this.$router.push({
        path: '/getScheme'
      })
    }
  }
}
</script>

<style scoped>

</style>
